import React, { Component } from 'react';
import { Row, Col, Media } from 'react-bootstrap';
import Auth from '../utils/auth.js';
import barbell from '../images/barbell.png';
import rings from '../images/rings.png';
import leaderboard from '../images/leaderboard.png';

const auth = new Auth();

class Login extends Component {

  constructor(props, context) {
    super(props, context)
    this.login = this.login.bind(this)
  }

  login() {
    auth.login();
  }

  render() {
    return (
      <Row>

        <Col sm={7}>

          <h1 className="login-header">Fantasy Fitness Draft</h1>

          <Media>
            <Media.Left align="middle">
              <img width={64} height={64} src={rings} alt="League"/>
            </Media.Left>
            <Media.Body>
              <Media.Heading>Create or Join a League</Media.Heading>
              <p>Start/join a league with your friends or with other CrossFit enthusiasts. </p>
            </Media.Body>
          </Media>

          <Media>
            <Media.Left align="middle">
              <img width={64} height={64} src={barbell} alt="League"/>
            </Media.Left>
            <Media.Body>
              <Media.Heading>Draft your Athletes</Media.Heading>
              <p>In snake order, pick any female or male Games athlete you want on your team.</p>
            </Media.Body>
          </Media>

          <Media>
            <Media.Left align="middle">
              <img width={64} height={64} src={leaderboard} alt="League"/>
            </Media.Left>
            <Media.Body>
              <Media.Heading>Watch the Leaderboard</Media.Heading>
              <p>August 1st, 2017 is game day! Watch your Fantasy Fitness Draft leaderboard to see how your athletes are performing against the other team members. </p>
            </Media.Body>
          </Media>

        </Col>

        <Col sm={5}>
          <h1>Sign Up</h1>
          <h3 className="login-text">Creating an account is easy, just sign in with your Facebook account.</h3>
          <p>&nbsp;</p>
          <a className="btn btn-block btn-social btn-lg btn-facebook" onClick={this.login}>Sign in with Facebook</a>
          <h5 className="login-text">* You may receive email notifications from FFD when we're ready to create new leagues. You can always opt out at any time.</h5>
        </Col>

      </Row>
    );
  }

}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js